export default __webpack_public_path__ + "static/media/juan-benet.2e998857.png";